import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/19024407855?text=Hi%20Bridge%20Taxi%2C%20I%27d%20like%20to%20book%20a%20ride."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group inline-flex items-center gap-2 rounded-full bg-[#25D366] pl-4 pr-5 py-3 text-white shadow-lg shadow-black/30 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#20bd5a]"
    >
      <MessageCircle className="h-6 w-6 shrink-0" />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp us</span>
    </a>
  );
}
